import { styled, Theme, Select, MenuList, Tabs, Tab } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';
import { CoreMenuItem } from '@youscience/core';

import ActionButton from '@components/ActionButton';

// TODO add color to library
const hoverBg = '#EBF6F7';

export const MenuPropsStyles = {
  PaperProps: {
    sx: (theme: Theme) => ({
      '& .Mui-selected': {
        backgroundColor: theme.palette.grey['100'],
      },

      li: {
        '&:hover': {
          // TODO add color to library
          backgroundColor: hoverBg,
        },
      },
    }),
  },
};

export const sxStyles = {
  headSectionWrap: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
  }),
  headSectionData: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  headTitle: {
    maxWidth: '700px',
    width: '100%',
    fontSize: '2.25rem',
    lineHeight: '3.375rem',
  },
  gradeWrap: {
    width: '196px',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  headSectionStatistics: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'end',

    '& > p:last-of-type': {
      marginTop: '0.5rem',
    },
  },
  completedTasks: {
    display: 'flex',
    flexWrap: 'wrap',
    marginLeft: '1rem',

    '& > span:last-of-type': {
      marginLeft: '1.5rem',
    },
  },
  progressBarWrap: {
    height: '5px',
    width: '100%',
    backgroundColor: coreThemeColors.primary.outlinedHoverBackground,
  },
  pageSubtitle: (theme: Theme) => ({
    color: theme.palette.grey['600'],
  }),
};

export const StyledHeadSectionInner = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  padding: '0 1rem',

  [theme.breakpoints.up('md')]: {
    padding: '0 5rem 0.5rem 5rem',
  },
}));

export const StyledProgressBar = styled('div', {
  shouldForwardProp: (prop) => prop !== 'completed',
})<{ completed: number }>(({ completed, theme }) => ({
  width: `${completed}%`,
  height: '100%',
  borderTopRightRadius: '5px',
  borderBottomRightRadius: '5px',
  backgroundColor: theme.palette.primary.main,
}));

export const StyledGradeSelect = styled(Select)(() => ({
  '.MuiOutlinedInput-notchedOutline': {
    borderRadius: '4px',
  },
}));

export const StyledArchivePageTitle = styled('div')(({ theme }) => ({
  padding: '1rem 1.5rem',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  '& > h3:first-of-type': {
    fontSize: '2.25rem',
    lineHeight: '3.375rem',
  },

  [theme.breakpoints.up('md')]: {
    padding: '2rem 5rem',
  },
}));

export const StyledInfoSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: 'calc(1540px + 10rem)',
}));

export const StyledSeasonTabs = styled(Tabs)(({ theme }) => ({
  marginTop: '2rem',
  padding: '0 1.5rem',

  [theme.breakpoints.up('md')]: {
    padding: '0 5rem',
  },
}));

export const StyledSeasonTabItem = styled(Tab)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '25%',
  minHeight: '54px',
  fontSize: '0.938rem',

  '& > svg:first-of-type': {
    marginBottom: '0.25rem',
    marginRight: '0.375rem',
  },
}));

export const StyledSeasonProgress = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  borderTop: `1px solid ${theme.palette.grey['300']}`,
  borderBottom: `1px solid ${theme.palette.grey['300']}`,
  padding: '0.5rem 1.5rem',

  '& > div:first-of-type': {
    marginRight: '1.5rem',
  },

  [theme.breakpoints.up('md')]: {
    padding: '1.5rem 5rem 0.5rem',
  },
}));

export const StyledActionsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0.5rem 1.5rem',

  [theme.breakpoints.up('md')]: {
    padding: '1.5rem 5rem',
  },
}));

export const StyledFilterChipsWrap = styled(MenuList, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color, theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  gap: '0.75rem',
  margin: '1rem 0',

  'li.Mui-selected': {
    color: theme.palette.common.white,
    backgroundColor: color,
    opacity: 0.8,

    '&:hover': {
      cursor: 'default',
      backgroundColor: color,
      opacity: 0.8,
    },
  },

  [theme.breakpoints.up('md')]: {
    margin: 0,
  },
}));

export const StyledFilterItem = styled(CoreMenuItem, {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color, theme }) => ({
  height: '26px',
  minHeight: 'auto',
  padding: '0 0.75rem',
  fontSize: '0.813rem',
  color,
  border: `1px solid ${color}`,
  borderRadius: '0.5rem',

  '&:hover': {
    color: theme.palette.common.white,
    backgroundColor: color,
    opacity: 0.5,
  },
}));

export const StyledFilterByStatusWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledFilterByStatusSelect = styled(Select)(({ theme }) => ({
  color: coreThemeColors.secondary.main,
  marginLeft: '0.5rem',

  '.MuiOutlinedInput-input': {
    fontSize: '0.875rem',
    padding: '0.5rem 1rem',
    marginRight: '0.35rem',
  },

  '.MuiOutlinedInput-notchedOutline': {
    borderRadius: '40px',
    border: `1px solid ${coreThemeColors.secondary.main}`,
    borderColor: `${coreThemeColors.secondary.main} !important`,
  },

  '& > svg:first-of-type': {
    color: coreThemeColors.secondary.main,
  },

  '&:hover': {
    '.MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${coreThemeColors.secondary.dark}`,
    },
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledAddNewTaskBtn = styled(ActionButton)(({ theme }) => ({
  minHeight: '40px',
  backgroundColor: coreThemeColors.secondary.main,
  borderRadius: '40px',

  '& > svg:first-of-type': {
    marginRight: '0.75rem',
  },

  '&:hover': {
    backgroundColor: coreThemeColors.secondary.dark,
  },

  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}));

export const StyledTaskCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  maxWidth: 'calc(1540px + 10rem)',
  padding: '0.5rem 1.5rem',

  [theme.breakpoints.up('md')]: {
    padding: '0.5rem 5rem',
  },
}));
